import { ApiFilterBase } from "@skailer-com/uikit/core";
import { ApiEmployeeShort } from "@/types/employees/employee.types.ts";

export interface ApiFormTemplateFilter extends ApiFilterBase {
  text?: string;
  folder_id?: number;
}

export interface ApiFormTemplate {
  id: number;
  title: string;
  total_questions: number;
  total_estimated_time_seconds: number;
  author: ApiEmployeeShort;
  folder: { id: number; title: string } | null;
  emoji: string | null;
}

export interface ApiFormTemplateSavePayload {
  title: string;
  folder_id?: number;
  emoji?: string;
}

export enum ApiFormTemplateType {
  survey = "survey",
  performance_review = "performance_review",
}

export interface ApiFormTemplateDuplicatePayload {
  target_type?: ApiFormTemplateType;
  folder_id?: number;
}

export interface ApiFormTemplateMovePayload {
  folder_id: number;
}
